import { Component, computed, inject, signal } from '@angular/core';
import { FormField, email, form, required, schema } from '@angular/forms/signals';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MceSaveCancelComponent, MceSaveCancelConfig, MceSaveCancelEvent } from '../../components/mce-save-cancel/mce-save-cancel.component';
import { invalidFields } from '../../functions/forms.helpers';

export interface UserEmailModel {
  acknowledged: boolean;
  email: string;
}

const userEmailSchema = schema<UserEmailModel>((path) => {
  required(path.email, { message: 'Email is required' });
  email(path.email, { message: 'Enter a valid email address' });
});

@Component({
  selector: 'mce-user-email-dialog',
  imports: [
    FormField,
    MceSaveCancelComponent,
    MatCheckboxModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  templateUrl: './user-email.component.html'
})
export class UserEmailComponent {
  readonly dialogRef = inject(MatDialogRef<UserEmailComponent>);

  readonly formModel = signal<UserEmailModel>({
    acknowledged: false,
    email: ''
  });
  readonly form = form<UserEmailModel>(this.formModel, userEmailSchema);

  readonly viewState = computed(() => ({
    enableSave: this.form.email().valid() && this.form.acknowledged().value(),
  }));

  protected readonly saveCancelConfig = computed<MceSaveCancelConfig>(() => ({
    save: { show: true, enable: this.viewState().enableSave },
    cancel: { show: true, enable: true },
    
  }));

  onSaveClick(): void {
    this.dialogRef.close(this.form().value());
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  onSaveCancelAction(event: MceSaveCancelEvent): void {
    if (event.type === 'save') {
      this.onSaveClick();
      return;
    }

    if (event.type === 'cancel') {
      this.onCancelClick();
    }
  }
}
